import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Drawer, { DrawerBody } from '@/design_system/Drawer';
import { Footer, FooterButtons } from '@/design_system/Footer';
import Stack from '@/design_system/Stack';
import Title from '@/design_system/Typography/Title';

export const FiltersDrawer = ({
  children,
  isOpen,
  onOpenChange,
  handleClearFilters,
  handleApplyFilters,
}: {
  children: React.ReactNode;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  handleClearFilters: () => void;
  handleApplyFilters: () => void;
}) => {
  const { t } = useLingui();

  return (
    <Drawer isOpen={isOpen} onOpenChange={onOpenChange} style={{ maxWidth: '21.875rem' }}>
      <DrawerBody
        style={{
          flex: 1,
          padding: '1.5rem 1rem',
        }}
      >
        <Title size="200" style={{ marginBottom: '1.5rem' }}>
          <Trans id="list.filters.drawer">Filters</Trans>
        </Title>

        <Stack gap="1rem">{children}</Stack>
      </DrawerBody>

      <Footer>
        <FooterButtons>
          <Button
            variant="secondary"
            size="medium"
            ariaLabel={t({ id: 'list.filters.drawer.clear', message: 'Clear' })}
            style={{ flex: 1 }}
            onPress={handleClearFilters}
          >
            <Trans id="list.filters.drawer.clear">Clear</Trans>
          </Button>

          <Button
            variant="primary"
            size="medium"
            ariaLabel={t({ id: 'list.filters.drawer.show-results', message: 'Show results' })}
            style={{ flex: 1 }}
            onPress={handleApplyFilters}
          >
            <Trans id="list.filters.drawer.show-results">Show results</Trans>
          </Button>
        </FooterButtons>
      </Footer>
    </Drawer>
  );
};
